import React from 'react';
import'./sec2.css'
import Titles from '../components/common/titles';
import Icontext from '../components/common/icontext';
import pic5 from '../assets/pic5.png'
import pic6 from '../assets/pic6.png'
import pic7 from '../assets/pic7.png'

const Sec2 = () => {
    return ( 
        <section className='sec2'>
                <article className='container-sec2'>
                    <article className='left-box-sec2'>
                            <article className='sub-box-left-sec2'>
                                <Titles title='Who We Are' stylee='title-left'/>
                                <p className='para-sec2'>We are a forward-thinking real estate
                                     developer committed to creating exceptional living spaces.
                                      With a passion for quality, innovation, and attention to 
                                      detail, we build communities designed to elevate everyday
                                       life.</p>
                            </article>


                            <article className='icons-part-sec2'>
                                <Icontext title='Experience Matters' 
                                para='Years of trusted real estate development.'
                                imgg={pic5}/>

                                <Icontext title='Excellence Delivered' 
                                para='Designing homes with quality and style.'
                                imgg={pic6}/>
                            </article>
                    </article>


                    <figure className='img-container-sec2'>
                        <img className='imggg-sec2-right' src={pic7} alt='img'></img>
                    </figure>




                </article>
        </section>
     );
}
 
export default Sec2;